import { useState } from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { useError } from '../contexts/ErrorContext';
import { getAGMsAndSubchainsAPI } from '../services/siteMapAPI';
import { adaptCoordinates } from '../utils/googleUtils';
import { nearestNeighbor, sortSubchainsByOrderNum } from '../utils/locationUtils';

/**
 * Gets agms and subchains for a job to draw the pipeline on the map
 * 
 * @param {number} JobID
 * 
 * @returns {Object[]} routeArr 
 * @returns {Object[]} subchains 
 * @returns {Object[]} agms
 * @returns {Function} fetchRouteArr
 * @returns {Function} clearStates
 * 
 * @category Hooks
 */
const useSiteMapRoute = () => {
    const [routeArr, setRouteArr] = useState([]);
    const [subchains, setSubchains] = useState([]);
    const [agms, setAgms] = useState([]);
    const { showLoading, hideLoading } = useLoading();
    const { showError } = useError();

    const clearStates = () => {
        setRouteArr([]);
        setSubchains([]);
        setAgms([]);
    }

    const fetchRouteArr = async (jobID) => {
        showLoading('Fetching Routes For Map...');
        try {
            const response = await getAGMsAndSubchainsAPI(jobID);
            
            if(response?.errorType){
                //error handling here
            } else {
                //calculate the routeArr for PolyLine on map
                //this needs to be organized by agm real chain then est chain
                
                
                let agms = response.data.agms.sort((a, b) => a.Real_Chain - b.Real_Chain)

                let route = [];
                for(let i = 0; i < agms.length; i++){
                    let currAgm = agms[i];
                    let nextAgm = agms[i+1];
                    if(nextAgm){
                        let subchainsBetweenAgms = [];
                        subchainsBetweenAgms.push(currAgm);
                        for(const sc of response.data.subchains){
                            if(sc.US_Site === currAgm.AGMID && sc.DS_Site === nextAgm.AGMID){
                                subchainsBetweenAgms.push(sc);
                            }
                        }
                        let sortedSCAndAgm = sortSubchainsByOrderNum(subchainsBetweenAgms);
                        if (!sortedSCAndAgm) {
                            sortedSCAndAgm = nearestNeighbor(subchainsBetweenAgms);
                        }
                        route.push(sortedSCAndAgm);
                    } else {
                        route.push(currAgm);
                        
                    }
                }
                setAgms(response.data.agms);
                setSubchains(response.data.subchains);
                route = route.flat();

                let adaptRouteKeysForGoogleAPI = adaptCoordinates(route);
                setRouteArr(adaptRouteKeysForGoogleAPI); 
            }              
        } catch (error) {
            console.log(error)
            showError(`Error Getting Jobs - ${error.message}`)
        } finally {
            hideLoading();
        }
    };    

    return { routeArr, subchains, agms, fetchRouteArr, clearStates };
};

export default useSiteMapRoute;
